export default "__VITE_ASSET__CfpyWkTu__"